export default __webpack_public_path__ + "static/media/Bandit's Gauntlets of the Grasslands.12b8ed39.jpg";